import React from 'react';
import s from '../../services/allservices.jsx'
import {
    Step,
    Stepper,
    StepLabel,
} from 'material-ui/Stepper';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import DefaultImg from '../../images/dummy.jpg'
import '../../stylesheet/addbynameemail.css'
// import { browserHistory } from 'react-router';
import {
   withRouter
} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux'
import * as actions from '../../actions/actions.jsx'

import LoaderSmall from "../loader/loadersmall.jsx"
/**
 * It is possible to specify your own step connector by passing an element to the `connector`
 * prop. If you want to remove the connector, pass `null` to the `connector` prop.
 */

const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194",
        maxWidth: 250,
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },


    radioButton: {
        marginBottom: 5,
        marginTop: 5,
        width: "33%",
        display: "inline"
    },
    blockmargin: {
        marginBottom: 10,
        marginRight: 10
    },
    labelStyle: {
        padding: 0,
        color: "#fff",
        marginTop: 20
    },
    inputStle: {
        marginRight: 5,
        marginTop: 10
    },
    groupstyle: {
        display: "flex",
        width: "100%"
    },
    radioIcon: {
        fill: "#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        friendsState: state.getFriendsReducer.friendsState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        fetchFriends() {
            dispatch(
                actions.getFriendsAction()
            )
        }
    })
const JSEncrypt = window.JSEncrypt
class AddFriendByNameAndMail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stepIndex: 0,
            nickName: "",
            email: "",
            firstName: "",
            lastName: "",
            emailState: true,
            firstNameState:true,
            correctEmail: true,
            searchState: [],
            userDetailState: {},
            message: "",
            value4: "email"
        };
        this.onChange = this.onChange.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.handletable = this.handletable.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleStep1 = this.handleStep1.bind(this)
        this.handleSearchByName = this.handleSearchByName.bind(this)
    }
    componentDidMount() {
        this.props.fetchPublicKey()
    }

    show1() {
        document.getElementById('emailid').style.display = 'block';
        document.getElementById('byname').style.display = 'none';
        document.getElementById("emailtext").value = ""
    }
    show2() {
        document.getElementById('byname').style.display = 'block';
        document.getElementById('emailid').style.display = 'none';
        document.getElementById("fnametext").value = "";
        document.getElementById("lnametext").value = ""
    }
    removefname=()=>{
        this.setState({
            firstNameState: true
        })
    }
    removeemail=()=>{
        this.setState({
            emailState: true
        })
    }
    handletable() {
        const { email } = this.state
        if (email === "") {
            this.setState({
                emailState: false
            })
        } else {
            let _this = this
            let state = { applicationId: "gmcabs", emailId: this.state.email, accountId: localStorage.getItem('accountId') }
            this.setState({
                loader: true
            })
            let token = "Token " + localStorage.getItem('token')
            fetch(s.find_member + "/?Authorization=" + token, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(state)
            })
                .then(
                    function (response) {
                        if (response.status === 500) {
                            response.json().then(function (object) {
                                _this.setState({
                                    loader: false
                                })
                            })
                        } else if (response.status === 200) {
                            response.json().then(function (json) {
                                
                                _this.setState({
                                    loader: false
                                })
                                _this.setState({
                                    searchState: json
                                }, () => {
                                    document.getElementById("record1").style.display = "block"
                                    if (document.getElementById("norecord1").style.display === "block") {
                                        document.getElementById("norecord1").style.display = "none"
                                        _this.setState({
                                            loader: false
                                        })
                                    }
                                })

                            })
                            
                        }

                        else if (response.status === 204) {
                            _this.setState({
                                loader: false
                            })
                            
                            if (document.getElementById("record1").style.display = "block") {
                                document.getElementById("record1").style.display = "none"
                            }
                            document.getElementById("norecord1").style.display = "block"
                            _this.setState({
                                loader: false
                            })
                        }


                    })
        }
        // document.getElementById('tabledata').style.display = 'block';
    }
  

    onChange(e, value) {
        if (e.target.name === "email") {
            if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(e.target.value)) {
                this.setState({
                    correctEmail: true,
                    email: value
                })
            } else {
                this.setState({
                    correctEmail: false
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }

    }

    handleShowMeOption = (event, index, value) => {
        this.setState({
            value4: event.target.value

        })
    }
    handleSearchByName() {
        const { firstName, lastName } = this.state
        if (firstName === "") {
            this.setState({
                firstNameState: false
            })
        } else {
            let _this = this
            const state = {
                applicationId: "gmcabs",
                firstName: firstName,
                lastName: lastName,
                accountId: localStorage.getItem('accountId')

            }
            this.setState({
                loader: true
            })
            let token = "Token " + localStorage.getItem('token')
            fetch(s.find_member + "/?Authorization=" + token, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(state)
            })
                .then(
                    function (response) {
                        if (response.status === 500) {
                            response.json().then(function (object) {
                                toast.error(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });
                                _this.setState({
                                    loader: false
                                })
                            })
                        } else if (response.status === 200) {
                            response.json().then(function (json) {
                            
                                _this.setState({
                                    loader: false
                                })
                                _this.setState({
                                    searchState: json
                                }, () => {
                                    document.getElementById("record").style.display = "block"
                                    if (document.getElementById("norecord").style.display = "block") {
                                        document.getElementById("norecord").style.display = "none"
                                    }
                                })

                                // document.getElementById("norecord").style.display = "none"
                                _this.setState({
                                    loader: false
                                })

                            })
                        }
                        else if (response.status === 204) {
                            if (document.getElementById("record").style.display = "block") {
                                document.getElementById("record").style.display = "none"
                            }
                            document.getElementById("norecord").style.display = "block"
                            _this.setState({
                                loader: false
                            })
                        }
                    })
        }
    }
    getStepContent(stepIndex) {
        const { emailState,firstNameState, correctEmail, searchState, userDetailState, message} = this.state
        switch (stepIndex) {
            case 0:
                return (
                    <div>
                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-sm-9">
                                    <div className="row">
                                        <RadioButtonGroup name="shipSpeed" defaultSelected="email" style={styles.groupstyle} onChange={this.handleShowMeOption.bind(this)}>
                                            <RadioButton
                                                value="email"
                                                label="By E-mail"
                                                style={styles.radioButton}
                                                iconStyle={styles.radioIcon}
                                                onClick={this.show1}
                                            />
                                            <RadioButton
                                                value="name"
                                                label="By Name"
                                                style={styles.radioButton}
                                                iconStyle={styles.radioIcon}
                                                onClick={this.show2}
                                            />
                                        </RadioButtonGroup>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12" id="emailid" >
                            <div className="row">
                                <div className=" col-sm-12 nopadding" >
                                    <div className="row input-group" >
                                        <div className="col-sm-1 emailinput" >
                                            <i className="fa fa-envelope text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-5 nopadding" >
                                            <TextField
                                                hintText="Typing"
                                                id="emailtext"
                                                floatingLabelText="Find a member by e-mail"
                                                type="text"
                                                name="email"
                                                maxLength="50"
                                                onChange={this.onChange}
                                                onFocus={this.removeemail}
                                                className="my-className input-width"
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                errorText={emailState ? correctEmail ? null : "Not a valid email" : "enter a valid email-id"}
                                            />
                                        </div>
                                        <div className="col-sm-2" style={{marginTop:"8px"}}>
                                            <RaisedButton
                                                label="Search"
                                                backgroundColor="#333"
                                                labelColor="#fff"
                                                onClick={this.handletable}
                                                buttonStyle={{ fontSize: "14px" }}
                                                style={{ minWidth: "50px", marginTop: "20px" }}
                                            />
                                        </div>{this.state.loader === true &&
                                        <div className="col-sm-1" style={{ width: "30% !mportant" }} >
                                        <LoaderSmall/>
                                     </div>}

                                    </div>
                                </div>

                            </div>
                            <div className="col-sm-12">
                                {this.state.value4 === "email" &&
                                    <div className="col-sm-12" id="tabledata1" style={{ display: "", fontSize: "14px", marginTop: "30px" }}>
                                        <div className="row nopadding">
                                            <table className="table table-striped" id="record1" style={{ display: "none" }}>
                                            <div className="scrollit nopadding">
                                                <thead>

                                                    <tr>

                                                        <th colSpan="5" scope="col">Member Listings <span style={{ fontSize: "10px", float: "right" }}>Members Found : {searchState.length} </span></th>

                                                    </tr>

                                                </thead>


                                                <tbody >
                                                    {
                                                        searchState.map((value, i) =>
                                                        <tr >
                                                                 
                                                        <th scope="row"><img src={DefaultImg} alt="" style={{ height: "40px", padding: "0px 12px 0px 0px" }} /> Name</th>
                                                        <td>	{searchState[i].name} <td className="nopadding" style={{ borderTop: "none" }} >{searchState[i].cardNumber}</td></td>
                                                        <th scope="row">City <th className="nopadding" scope="row" style={{ borderTop: "none" }}>State</th></th>
                                                        <td>{searchState[i].city} <td className="nopadding" style={{ borderTop: "none" }} >{searchState[i].state}</td> </td>


                                                               <td><button style={{backgroundColor:"#333",color:"#fff" , border:"none" , overflow:"srcoller"}} onClick={(e) => { this.sendUserDetail(searchState[i]) }}>Add Card Account</button></td>



                                                            </tr>
                                                        )


                                                    }

                                                </tbody>
                                                </div>
                                            </table>

                                            <div id="norecord1" style={{ display: "none", fontSize: "20px", position: "absolute", left: "230px" }}>
                                            
                                                No Records Found
                                 </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className=" col-sm-12 " id="byname" style={{ display: "none" ,padding:"0px 20px"}}>
                            <div className="row">
                                <div className="col-sm-4 nopadding">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 nameinput" >
                                            <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10 nopadding" >
                                            <TextField
                                                hintText="Typing"
                                                floatingLabelText="Enter FirstName"
                                                id="fnametext"
                                                type="text"
                                                maxLength="30"
                                                name="firstName"
                                                
                                                onChange={this.onChange}
                                                className="my-className input-width required"
                                                onFocus={this.removefname}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                
                                                errorText={firstNameState ? null : "This field is required"}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="offset-sm-1 col-sm-4 nopadding">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10 nopadding" >
                                            <TextField
                                                hintText="Typing"
                                                floatingLabelText="Enter LastName"
                                                id="lnametext"
                                                type="text"
                                                maxLength="30"
                                                name="lastName"
                                                onChange={this.onChange}
                                                className="my-className input-width"
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-2"  style={{marginTop:"8px"}}>
                                    <RaisedButton
                                        label="Search"
                                        backgroundColor="#333"
                                        labelColor="#fff"
                                        onClick={this.handleSearchByName}
                                        style={{ minWidth: "50px", marginTop: "20px" }}
                                    />
                                </div>
                                {this.state.loader === true &&
                                        <div className="col-sm-1" style={{ width: "30% !mportant" }} >
                                        <LoaderSmall/>
                                     </div>}
                            </div>
                            </div>
                            <div className="col-sm-12">
                                {this.state.value4 === "name" &&
                                    <div className="col-sm-12" id="tabledata" style={{ display: "", fontSize: "14px", marginTop: "30px" }}>
                                    <div className="row nopadding ">
                                    
                                        <table className="table table-striped" id="record" style={{ display: "none" }}>
                                        <div className="scrollit nopadding">
                                            <thead>

                                                <tr>

                                                    <th colSpan="5" scope="col">Member Listings <span style={{ fontSize: "10px", float: "right" }}>Members Found : {searchState.length} </span></th>

                                                </tr>

                                            </thead>


                                            <tbody >
                                                {
                                                    searchState.map((value, i) =>
                                                        <tr >
                                                             
                                                            <th scope="row"><img src={DefaultImg} alt="" style={{ height: "40px", padding: "0px 12px 0px 0px" }} /> Name</th>
                                                            <td>	{searchState[i].name} <td className="nopadding" style={{ borderTop: "none" }} >{searchState[i].cardNumber}</td></td>
                                                            <th scope="row">City <th className="nopadding" scope="row" style={{ borderTop: "none" }}>State</th></th>
                                                            <td>{searchState[i].city} <td className="nopadding" style={{ borderTop: "none" }} >{searchState[i].state}</td> </td>


                                                            <td><button style={{backgroundColor:"#333",color:"#fff" , border:"none" , overflow:"srcoller"}} onClick={(e) => { this.sendUserDetail(searchState[i]) }}>Add Card Account</button></td>


                                                        </tr>
                                                    )


                                                }

                                            </tbody>
                                            </div>
                                        </table>
                                            
                                            <div id="norecord" style={{ display: "none", fontSize: "20px", position: "absolute", left: "230px" }}>

                                                No Records Found
                             </div>
                                        </div>

                                    </div>
                                }
                            </div>
                        
                    </div>
                );

            case 1:
                return (
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="tile box-shadow-style">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="row">
                                            <div className="col-md-3 tilepadding">
                                                <label className="tilecontent" style={{ wordBreak: "break-all" }}>Name</label>
                                            </div>
                                            <div className="col-md-6 text-left tilepadding">
                                                <span className="tileheadername"> : {userDetailState.name} </span><br />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 tilepadding">
                                                <label className="tilecontent"style={{ wordBreak: "break-all" }}>City </label>
                                            </div>
                                            <div className="col-md-6 text-left tilepadding">
                                                <span className="tileheadername"> : {userDetailState.city} </span><br />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                        <div className="row">
                                            <div className="col-md-3  tilepadding">
                                                <label className="tilecontent">Card Account</label>
                                            </div>
                                            <div className="col-md-8 text-left tilepadding">
                                                <span className="tileheadername"> : {userDetailState.cardNumber}  </span><br />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3  tilepadding">
                                                <label className="tilecontent"style={{ wordBreak: "break-all" }}>State</label>
                                            </div>
                                            <div className="col-md-8 text-left tilepadding">
                                                <span className="tileheadername"> : {userDetailState.state}</span><br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12" style={{ display: "block" }}>
                            <div className="row">
                                <div className="col-sm-5">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10 nopadding" >
                                            <TextField
                                                hintText="Typing"
                                                floatingLabelText="Nickname"
                                                type="text"
                                                id="nickName"
                                                name="nickName"
                                                value={this.state.nickName || ""}
                                                maxLength="50"
                                                style={{ wordBreak: "break-all" }}
                                                onChange={this.onChange}
                                                className="my-className input-width required"
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="col-sm-6">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-commenting-o text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-10 nopadding" >
                                            <TextField
                                                hintText="Typing"
                                                floatingLabelText={"Message To " + userDetailState.name}
                                                type="text"
                                                name="message"
                                                maxLength="100"
                                                onChange={this.onChange}
                                                style={{ wordBreak: "break-all" }}
                                                className="my-className input-width"
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                );

            case 2:
            const {nickName} = this.state
                return (
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="tile box-shadow-style">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="row">
                                            <div className="col-md-5 tilepadding">
                                                <label className="tilecontent" >Name</label>
                                            </div>
                                            <div className="col-md-6 text-left tilepadding">
                                                <span className="tileheadername" style={{ wordBreak: "break-all" }}> : {userDetailState.name} </span><br />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 tilepadding">
                                                <label className="tilecontent">Card Account</label>
                                            </div>
                                            <div className="col-md-7 text-left tilepadding">
                                                <span className="tileheadername"> : {userDetailState.cardNumber}  </span><br />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-4 col-sm-12">
                                        <div className="row">
                                            <div className="offset-md-1 col-md-4 tilepadding">
                                                <label className="tilecontent">City</label>
                                            </div>
                                            <div className="col-md-6 text-left tilepadding">
                                                <span className="tileheadername" style={{ wordBreak: "break-all" }}> : {userDetailState.city} </span><br />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="offset-md-1 col-md-4 tilepadding">
                                                <label className="tilecontent">NickName</label>
                                            </div>
                                            <div className="col-md-6 text-left tilepadding">
                                                <span className="tileheadername " style={{ wordBreak: "break-all" }}> : {nickName} </span><br />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-3 col-sm-12">
                                        <div className="row">
                                            <div className="offset-md-1 col-md-4 tilepadding">
                                                <label className="tilecontent" style={{ wordBreak: "break-all" }}>State</label>
                                            </div>
                                            <div className="col-md-7 text-left tilepadding">
                                                <span className="tileheadername"> : {userDetailState.state}</span><br />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="offset-md-1 col-md-4 tilepadding">
                                                <label className="tilecontent">Message</label>
                                            </div>
                                            <div className="col-md-7 text-left tilepadding">
                                                <span className="tileheadername" style={{ wordBreak: "break-all" }}> : {message}</span><br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div>Something Went Wrong</div>
                )
        }
    }
    sendUserDetail(userDetail) {
        this.setState({ stepIndex: 1, userDetailState: userDetail },()=>{

        });
    }
    handleNext() {
        const { stepIndex } = this.state;

        if (stepIndex < 2) {
            this.setState({ stepIndex: stepIndex + 1 });
        }
    }

    handlePrev() {
        const { stepIndex } = this.state;

        if (stepIndex > 0) {
            this.setState({ stepIndex: stepIndex - 1 });
        }
    }
    handleStep1() {
        if (this.state.nickName.length !== 0) {
            this.setState({ stepIndex: 2 });
        }
        else {
            toast.error("enter nick name", {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });
        }

    }
    handleSubmit() {
        // const state = {
        //     applicationId: "gmcabs",
        //     accountId: localStorage.getItem("accountId"),
        //     cardDetailsId: this.state.userDetailState.cardDetailsId,
        //     message: this.state.message,
        //     nickName: this.state.nickName
        // }
       
        const { publicKey } = this.props

        let token = "Token " + localStorage.getItem('token')
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            const state = {
                applicationId: "gmcabs",
                accountId: encrypt.encrypt(localStorage.getItem("accountId")),
                cardDetailsId: encrypt.encrypt(this.state.userDetailState.cardDetailsId),
                message: encrypt.encrypt(this.state.message),
                nickName: encrypt.encrypt(this.state.nickName)
            }
            let _this = this
            fetch(s.add_friend + "/?Authorization=" + token, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(state)
            })
                .then(
                    function (response) {
                        if (response.status === 200 || response.status === 201 || response.status === 204) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            _this.props.fetchFriends();

                            setTimeout(function () {
                                window.location.reload(1);
                            }, 3000);
                        
                    }
                        else {
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            response.json().then(function (object) {

                            })
                            setTimeout(function () {
                                window.location.reload(1);
                            }, 3000);
                        }
                    })
        }
    }

    render() {
        const { stepIndex } = this.state;

        return (
            <div style={{ width: '100%', maxWidth: 700, margin: 'auto' }}>
                <ToastContainer
                    draggablePercent={60}
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <Stepper activeStep={stepIndex} connector={<ArrowForwardIcon />}>
                    <Step className="step">
                        <StepLabel>Find a Member</StepLabel>
                    </Step>

                    <Step className="step">
                        <StepLabel>Card Account Info</StepLabel>
                    </Step>

                    <Step className="step">
                        <StepLabel>Verify & Submit</StepLabel>
                    </Step>
                </Stepper>

                {this.getStepContent(stepIndex)}

                <div style={{ marginTop: 24, marginBottom: 12 }}>
                    {stepIndex === 0 ? null :
                        <RaisedButton
                            label={stepIndex === 2 ? 'Finish' : 'Next'}
                            onClick={stepIndex === 2 ? this.handleSubmit : stepIndex === 1 && this.handleStep1}
                            style={styles.button}
                            backgroundColor="#333"
                            labelColor="#fff"
                        />}
                </div>
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddFriendByNameAndMail));


// WEBPACK FOOTER //
// ./src/components/friends/addbynameemail.jsx